export default "__VITE_ASSET__DHNW0738__"